export class Model_Forex_CRM_CompanyType
    {      
  
            public CompanyTypeId : number;
            public CompanyType   :string;
                   
    }       